import * as React from 'react';

import { useDebouncedCallback } from 'use-debounce';

import { Icon } from './icon';
import { cn } from '@/new/lib/utils';

export interface DebouncedSearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onSearchCall: (text: string) => void;
  debounceMs?: number;
}

export const DebouncedSearchInput = React.forwardRef<HTMLInputElement, DebouncedSearchInputProps>(
  ({ className, onSearchCall, debounceMs = 300, ...props }, ref) => {
    const [value, setValue] = React.useState('');

    const debouncedSearch = useDebouncedCallback((text: string) => {
      onSearchCall(text);
    }, debounceMs);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      setValue(newValue);
      debouncedSearch(newValue);
    };

    return (
      <div
        className={cn(
          'flex items-center rounded-lg border border-gray-300 bg-white duration-150 focus-within:border-gray-400',
          className,
        )}
      >
        <Icon className="lucide--search mx-3 text-base text-gray-400" />
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={handleChange}
          className="w-full py-2 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:outline-none"
          {...props}
        />
      </div>
    );
  },
);
DebouncedSearchInput.displayName = 'DebouncedSearchInput';
